import React, { useState} from 'react';
import TV_Pic from "../../../icons/products2024/TV_Pic.png"

import FotoVirtuale from "../../../icons/icon/new/FotoVoltaicoVirtuale.png"
import Pompa from "../../../icons/icon/pompa.png"
import { useSelector } from 'react-redux';
import {
    get
} from '../../../reducers/data';
import FotoRinghiera from "../../../icons/products2024/Foto_Ringhiera.png"
import FotoMuratura from "../../../icons/products2024/Foto_Muratura.png"
import { Row, Col } from 'react-bootstrap';
import ProductModalComponent from './ProductModal';
import zoom_in from '../../../icons/zoom_in.svg';
import Frigo_75 from "../../../icons/icon/new/Frigo_75.png"
import Frigo_Bespoke from "../../../icons/icon/new/Frigo_Bespoke.png"
import Foto_Batteria from "../../../icons/icon/new/Foto_Batteria.png"
import Foto_Solare from "../../../icons/icon/new/Foto_Solare.png"
import expand_less from "../../../icons/expand_less.svg"
import expand_more from "../../../icons/expand_more.svg"
import check_blue from "../../../icons/check_blue.svg"
import Piastra60 from "../../../icons/products2024/Piastra_60cm.png";
import Piastra60DF from "../../../icons/products2024/Piastra_60cm_DF.png";
import Lavatrice1 from "../../../icons/products2024/Lavatrice1.png";
import Lavatrice2 from "../../../icons/products2024/Lavatrice2.png";

const images = {
    TV_Pic,
    FotoVirtuale,
    Pompa,
    FotoRinghiera,
    FotoMuratura,
    Frigo_75, 
    Frigo_Bespoke, 
    Foto_Batteria, 
    Foto_Solare,
    Piastra60,
    Piastra60DF,
    Lavatrice1,
    Lavatrice2        
}

const Number = ({ big, comma }) => {
    return <div className="d-flex price-text justify-content-end mb-2"> 
        <p className="big"> {big} </p>
        <div className="d-flex flex-column small justify-content-between">
            <p className="f22 mb-0">,{comma} €*</p>
            <p className="f16 mb-1"> IVA Inclusa</p>
        </div>
    </div>
}

const FotoV = ({ big, comma }) => {
    return <div className="d-flex price-text justify-content-end mb-2"> 
        <p className="big"> {big} </p>
        <div className="d-flex flex-column small justify-content-between">
            <p className="f22 mb-0"></p>
            <p className="f16 mb-1">{comma}</p>
        </div>
    </div>
}


const tv = {
    true: { //negozi
        "32\"": {big: "12", comma: "99", totale: "311,76", tan: "TAN 0% - TAEG 0%", tipo: "Televisione", description:"Con la risoluzione Full HD e la tecnologia PurColor di Samsung, i tuoi contenuti avranno colori più realistici e dettagli definiti per un’esperienza visiva coinvolgente. L’audio è immersivo grazie a Object Tracking Sound Lite, che fa seguire il suono all’azione sullo schermo, mentre Adaptive Sound ottimizza automaticamente dialoghi e scene per offrirti sempre la resa migliore. Con il sistema operativo Tizen hai accesso alle principali piattaforme di streaming come Netflix, Disney+ e Prime Video e al Gaming Hub, che trasforma il TV in una console di gioco collegando semplicemente un controller. Il design sottile con cornici ridotte valorizza le immagini e i piedini laterali donano stabilità e un tocco elegante che si adatta perfettamente a ogni ambiente.", tags:["FHD", "LED", "SLIM LOOK"] },//MISSING
        "43\"": {big: "15", comma: "99", totale: "383,76", tan: "TAN 0% - TAEG 0%", tipo: "Televisione" },
        "55\"":  {big: "17", comma: "99", totale: "431,80", tan: "TAN 0% - TAEG 0%", tipo: "Televisione" },
        "65\"":  {big: "25", comma: "99", totale: "623,80", tan: "TAN 0% - TAEG 0%", tipo: "Televisione" },
        "77\"":  {big: "85", comma: "99", totale: "2.063,76", tan: "TAN 0% - TAEG 0%", tipo: "Televisione", description:"Con il pannello OLED e il processore NQ4 AI Gen2, il TV Samsung OLED S85F offre immagini davvero spettacolari in 4K, con neri profondissimi, colori verificati e fedeli certificati Pantone e contrasto e luminosità ottimizzati per ogni scena. Il suono avvolge grazie a Object Tracking Sound Lite, con Adaptive Sound Pro che adatta dialoghi ed effetti sonori all’ambiente e al contenuto visivo. Il sistema operativo Tizen ti mette subito a disposizione le app di streaming (Netflix, Disney+, Prime Video…); il Gaming Hub, insieme alle funzioni come Auto Low Latency Mode (ALLM), VRR e Motion Xcelerator a 120 Hz, trasforma il TV in una console pronta all’uso. Il design elegante e sottile, con cornici quasi invisibili e piedini discreti, oltre a una struttura raffinata, si integra perfettamente nei tuoi ambienti migliorando lo stile complessivo.", tags:["4k", "NQ4 AI Gen2 Processor", "OLED"] },  //MISSING
    },
    false: { //online
        "32\"": {big: "18", comma: "35", totale: "338,64", tan: "TAN 6.75% - TAEG 5.85%", tipo: "Televisione", rate: 18, description:"Con la risoluzione Full HD e la tecnologia PurColor di Samsung, i tuoi contenuti avranno colori più realistici e dettagli definiti per un’esperienza visiva coinvolgente. L’audio è immersivo grazie a Object Tracking Sound Lite, che fa seguire il suono all’azione sullo schermo, mentre Adaptive Sound ottimizza automaticamente dialoghi e scene per offrirti sempre la resa migliore. Con il sistema operativo Tizen hai accesso alle principali piattaforme di streaming come Netflix, Disney+ e Prime Video e al Gaming Hub, che trasforma il TV in una console di gioco collegando semplicemente un controller. Il design sottile con cornici ridotte valorizza le immagini e i piedini laterali donano stabilità e un tocco elegante che si adatta perfettamente a ogni ambiente.", tags:["FHD", "LED", "SLIM LOOK"]},//MISSING
        "43\"": {big: "17", comma: "04", totale: "409,96", tan: "TAN 5.75% - TAEG 5.85%", tipo: "Televisione" },
        "55\"": {big: "22", comma: "37", totale: "536,88", tan: "TAN 5.75% - TAEG 5.85%", tipo: "Televisione" },
        "65\"": {big: "27", comma: "70", totale: "664,80", tan: "TAN 5.75% - TAEG 5.85%", tipo: "Televisione" },
        "77\"": {big: "91", comma: "64", totale: "2.199,36", tan: "TAN 5.75% - TAEG 5.88%", tipo: "Televisione",  description:"Con il pannello OLED e il processore NQ4 AI Gen2, il TV Samsung OLED S85F offre immagini davvero spettacolari in 4K, con neri profondissimi, colori verificati e fedeli certificati Pantone e contrasto e luminosità ottimizzati per ogni scena. Il suono avvolge grazie a Object Tracking Sound Lite, con Adaptive Sound Pro che adatta dialoghi ed effetti sonori all’ambiente e al contenuto visivo. Il sistema operativo Tizen ti mette subito a disposizione le app di streaming (Netflix, Disney+, Prime Video…); il Gaming Hub, insieme alle funzioni come Auto Low Latency Mode (ALLM), VRR e Motion Xcelerator a 120 Hz, trasforma il TV in una console pronta all’uso. Il design elegante e sottile, con cornici quasi invisibili e piedini discreti, oltre a una struttura raffinata, si integra perfettamente nei tuoi ambienti migliorando lo stile complessivo.", tags:["4k", "NQ4 AI Gen2 Processor", "OLED"]} //MISSING    
    }
}


const ProductBox = ({ 
    title, serie, description, image, selected, 
    tags, topChildren, extraTitleCell, children, 
    tipo, action, bottom }) => {
    const data = useSelector(get);
    let extraTitle = ""
    const [show, setShow] = useState(false);
    const [showDesc, setShowDesc] = useState(false); 
    const negozi = data["negozi"] ?? false;
    if (title?.includes("Plug")) { 
        if (data["TipologiaBalconi"] === "Muratura"){
            image = "FotoMuratura"
            // serie = "Fotovoltaico da parete / balcone "
            // topChildren.tipo = "Fotovoltaico da parete"
            serie ="Fotovoltaico da appartamento"
            topChildren.tipo = "Fotovoltaico da appartamento"
        }
        else {
            image = "FotoRinghiera"
            // serie = "Fotovoltaico da balcone con ringhiera"
            // topChildren.tipo = "Fotovoltaico da balcone"
            serie ="Fotovoltaico da appartamento"
            topChildren.tipo = "Fotovoltaico da appartamento"
        }
    }
    const isNegozi = data["negozi"]
    if (!topChildren && !tipo){
        topChildren = tv[isNegozi]["43\""]
    }
    if (extraTitleCell && extraTitleCell === "User_TV") {
        topChildren = tv[isNegozi]["43\""]
    }

    let selectedTv = tv[isNegozi]["43\""];
    if (extraTitleCell && data[extraTitleCell] && extraTitleCell === "User_TV") {
        extraTitle = data[extraTitleCell].split(" ").pop()
        if (extraTitle === 'U8000F' || extraTitle === 'F6000F' || 'S85F') { 
            extraTitle = data[extraTitleCell].split(" ").slice(-2,-1)[0]
        }
        topChildren = tv[isNegozi][extraTitle]
        selectedTv = tv[isNegozi][extraTitle]
    } 
    console.log(selectedTv)
    const finalTags = selectedTv?.tags ?? tags;

    return (
        <>
        <Row className={"redesign-product-box " + (selected ? "selected" : "")}>
            <Col sm={12} lg={4} >
             <div className="product-image">
                <img  src={images[image]} alt={title} role="presentation" />
                </div>
            </Col>
            <Col sm={12} lg={8} >
                <p className="serie mt-2 mt-lg-0" dangerouslySetInnerHTML={{ __html: serie}}></p>
                <h2 className="title"> <b> {title} {extraTitle}</b></h2>
                {showDesc && 
                <p className="description f16" dangerouslySetInnerHTML={{ __html: selectedTv.description ?? description}}></p>}
                <div className="d-none d-lg-block f12" style={{ color: "#D3135A", cursor: "pointer"}} onClick={() => setShowDesc(!showDesc)}>  
                    { !showDesc ? <>Mostra descrizione prodotto <img src={expand_more} description="" role="presentation" />  </>  : <>Nascondi descrizione prodotto <img src={expand_less} description="" role="presentation" /></> } </div>
                { finalTags && <ul style={{ listStyleType: "none", padding: 0, marginTop: "0rem"}}>
                    {finalTags.map((tag, index) => <li key={index}> <img src={check_blue} alt="" role="presentation" /> <b className="f14"> {tag}</b></li> )}
                </ul>}

                <div className="d-lg-none mt-4 scopri" onClick={() => setShow(true)}> Scopri di più sul prodotto <img src={zoom_in} alt="" role="presentation" /> </div>
            </Col>
          
        {topChildren?.extra && <div  className="my-3">  </div>}
            {(children || topChildren) &&<Col className="mx-12 mt-3" style={{ position:"relative"}}>
              {topChildren?.extra && <div  className="extra"> {topChildren.extra} </div>}
                <Row className="price-box">
                    <Col sm={3} lg={6} > <b className="f12">Prezzo {topChildren ? topChildren.tipo : tipo}</b> </Col>
                    <Col sm={9} lg={6} className="text-end" >
                     {topChildren && <>
                        {topChildren.topCopy ?  <p className="mb-0 f12">{topChildren.topCopy}</p> :  <p className="mb-0 f12"> <b>{topChildren.rate ?? 24}</b> mensili da </p>}
                       
                        {<Number {...topChildren} />}
                        <p className="f14 mb-2"> <b> {topChildren.tan} </b></p>
                        {topChildren.totale && <p className="f12 mb-0">Totale: {topChildren.totale} €</p>}
                    </>}
                    {children}
                    </Col>
                </Row>
            </Col>}
            {bottom && bottom.map((x, i) =><Col sm={12} className="mt-2 mx-12 w-100" key={i}> 
            <Row className="price-box mt-3" >
                    <Col sm={3} lg={6} > <b className="f12">{x.title}</b> </Col>
                    <Col sm={9} lg={6} className="text-end" >
                        <FotoV {...x} />
                        {x.sub && <p className="f14 mb-0"> <b> {x.sub} </b></p>}
                        <p className="f12 mb-0">IVA inclusa</p>
                    </Col>
                </Row>
                </Col>)
            }
            {action && <div className="px-3 mt-3">
                      {action} 
        </div>}
        </Row>
      
        <ProductModalComponent 
            show={show}
            chiudi={() => setShow(false)}
            extraTitle={title}
            serie={serie}
            tags={selectedTv.tags ?? tags}
            description={selectedTv.description ?? description}
            image={images[image]}
        />
         </>
    );
};

export default ProductBox;